<template>
  <v-text-field v-model="thisValue" label="Reference" hint="Optional. Use this to add your own reference for the order." persistent-hint></v-text-field>
</template>

<script>
export default {
  name: 'OrderDetailReference',
  computed: {
    thisValue: {
      get () {
        return this.$store.state.order.reference
      },
      set (val) {
        this.$store.commit('updateOrder', ['reference', val])
      }
    }
  }
}
</script>

<style scoped>

</style>
